import React from 'react';
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { FastField, Form, Formik } from "formik";
import Box from "@material-ui/core/Box";
import Preloader from "../common/Preloader/Preloader";
import { themeButtons } from "../../css/themeButtons";
import Button from "@material-ui/core/Button";


const ChannelManager = (props) => {
  const { objectId, channelManagerList, setChannelManagerPage, channelManagerId } = props


  const onSubmit = (value) => {
    setChannelManagerPage({ object: objectId, section: "channelManager", data: { id: value.channelManagerId } })
  }


  const buttons = themeButtons()

  if (!channelManagerList) {
    return <Preloader loading={true}/>
  }
  return (
    <div className="main edit-object hide-fs">
      <div className="container-fluid">
        <Formik initialValues={{ channelManagerId: channelManagerId ? channelManagerId : '' }}
                enableReinitialize
                onSubmit={onSubmit}>
          {({ values }) =>
            <Form>
              <div className="row g-2 align-items-center mb-3">
                <div className="col-md-6">
                  <FastField name="channelManagerId">
                    {({ field }) => (
                      <FormControl variant="outlined"
                                   size="small"
                                   fullWidth>
                        <InputLabel>Менеджер каналов</InputLabel>
                        <Select
                          label="Менеджер каналов"
                          {...field}
                        >
                          {channelManagerList.map(channel => {
                            return <MenuItem key={channel.id} value={channel.id}>
                              {channel.name}
                            </MenuItem>
                          })}
                        </Select>
                      </FormControl>
                    )}
                  </FastField>
                </div>
                {!channelManagerId
                  ? <div className="col-md-6">
                    <Box className="alert alert-danger mb-0">
                      Выберите менеджер каналов из предложенного списка
                    </Box>
                  </div>
                  : <div className="col-md-6">
                    <Box className="alert alert-success mb-0">
                      Вы
                      используете {channelManagerList.filter(item => item.id === channelManagerId)[0].name}
                    </Box>
                  </div>
                }
              </div>


              {!values.channelManagerId && values.channelManagerId !== channelManagerId && <div>
                <h4>Как подключить менеджер каналов к объекту</h4>
                <ol>
                  <li>Необходимо выбрать менеджер каналов из списка, который находится в верхней части
                    страницы
                  </li>
                  <li>После выбора будет показана инструкция к этому менеджеру каналов</li>
                </ol>
              </div>}
              {!!values.channelManagerId && values.channelManagerId !== channelManagerId && <>
                <div
                  dangerouslySetInnerHTML={{ __html: channelManagerList.filter(cm => cm.id === values.channelManagerId)[0].textBefore ? channelManagerList.filter(cm => cm.id === values.channelManagerId)[0].textBefore : "asdasd" }}>

                </div>
                <Button type="submit" className={`btn ${buttons.btnGreen}`}>Подключить</Button>
              </>}


            </Form>
          }


        </Formik>

      </div>
    </div>


  );
}


export default ChannelManager;
